// extracted by mini-css-extract-plugin
export default {"table":"Fees_table__zZnYo","text":"Fees_text__57Zvo","heading-classname":"Fees_heading-classname__WlApc","inner-link":"Fees_inner-link__Pp4w6"};